import script from "./WPreviewFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./WPreviewFooter.vue?vue&type=script&setup=true&lang=ts"

import "./WPreviewFooter.vue?vue&type=style&index=0&id=74b6a3b0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74b6a3b0"]])

export default __exports__